import { isUISchemaElement } from "@certn/application";
import { Text, mq } from "@certn/cascadia-react";
import {
  CascadiaJsonForm,
  CascadiaJsonFormContent,
  renderers,
} from "@certn/forms";
import { css } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { ComplianceReviewHoldNotice } from "../review-hold/ComplianceReviewHoldNotice";
import { isComplianceReviewHoldStatus } from "../review-hold/utils";
import {
  CheckResult,
  FulfillmentNotes as FulfillmentNotesSchema,
} from "../types";
import { hasExternalFulfillmentNotes } from "./utils";
import { FulfillmentNotes } from "../fulfillment-notes/FulfillmentNotes";

interface Props {
  checkResult: CheckResult;
  fulfillmentNotes?: FulfillmentNotesSchema;
  isPDF?: boolean;
}

export function CollapsiblePanel(props: Props) {
  const { t } = useTranslation();
  const styles = useStyles();
  const { checkResult, fulfillmentNotes } = props;
  const { short_id, status } = checkResult;
  const isComplianceReviewHold = isComplianceReviewHoldStatus(status);

  return (
    <div className={styles.openResult}>
      <Text style="form/body-primary" testID="check-id">
        {t("Check ID")}: {short_id}
      </Text>
      {isComplianceReviewHold && <ComplianceReviewHoldNotice />}
      <CascadiaJsonForm
        initialValues={checkResult.results}
        schema={checkResult.results_data_schema}
        uischema={
          isUISchemaElement(checkResult.results_ui_schema)
            ? checkResult.results_ui_schema
            : undefined
        }
        isSummary={false}
        renderers={[...renderers]}
        readonly
      >
        <CascadiaJsonFormContent />
      </CascadiaJsonForm>
      {fulfillmentNotes && hasExternalFulfillmentNotes(fulfillmentNotes) && (
        <FulfillmentNotes fulfillmentNotes={fulfillmentNotes} />
      )}
    </div>
  );
}

function useStyles() {
  return {
    openResult: css(
      mq({
        margin: ["0 var(--space-4) var(--space-4)"],
        "@media print": {
          marginLeft: 0,
          marginRight: 0,
        },
        paddingTop: "var(--space-4)",
        display: "grid",
        gap: "var(--space-6)",
      })
    ),
  };
}
